/* eslint-disable react/react-in-jsx-scope */
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Swal from 'sweetalert2';
import { IReducer } from '../../../../../../redux/configureStore';
import { getApiTransfer } from '../../../../../../redux/fetchActions/legadoPage/transferApp';
import SearchButton from '../../../../../../shared/components/buttons/SearchButton';
import Filter from '../../../../../../shared/components/Filter';
import Wrapper from '../../../../../../shared/components/Wrapper';
import SetDatetime from './components/FirstRow/SetDatetime';
import SetPeriod from './components/FirstRow/SetPeriod';
import SetValue from './components/FirstRow/SetValue';
import SetCodLeg from './components/FourthRow/SetCodLeg';
import SetIDTransaction from './components/FourthRow/SetIDTransaction';
import SetSituation from './components/FourthRow/SetSituation';
import SetAccountCred from './components/SecondRow/SetAccountCred';
import SetAgencyCred from './components/SecondRow/SetAgencyCred';
import SetDocumentCred from './components/SecondRow/SetDocumentCred';
import SetNameCred from './components/SecondRow/SetNameCred';
import SetPartner from './components/SetPartner';
import SetType from './components/SetType';
import SetAccountDeb from './components/ThirdRow/SetAccountDeb';
import SetAgencyDeb from './components/ThirdRow/SetAgencyDeb';
import SetDocumentDeb from './components/ThirdRow/SetDocumentDeb';
import SetNameDeb from './components/ThirdRow/SetNameDeb';

export function transfersFilter() {
  const dispatch = useDispatch();
  const [collapse, setCollapse] = useState(false);

  const transfersFilterState = useSelector(
    (reducer: IReducer) => reducer.transfersFilterApp
  );

  const transfersState = useSelector(
    (reducer: IReducer) => reducer.transfersApp
  );

  function verificarPeriodo30Dias(data1, data2) {
    const msPorDia = 24 * 60 * 60 * 1000;
    const dataInicio = new Date(data1);
    const dataFim = new Date(data2);
    const timestampInicio = dataInicio.getTime();
    const timestampFim = dataFim.getTime();
    const diferencaMs = Math.abs(timestampFim - timestampInicio);
    const diferencaDias = Math.round(diferencaMs / msPorDia);

    if (diferencaDias <= 30) {
      return true;
    }
    return false;
  }

  function dispathData() {
    if (
      !verificarPeriodo30Dias(
        String(transfersFilterState.dateFrom),
        String(transfersFilterState.dateTo)
      )
    ) {
      Swal.fire({
        icon: 'warning',
        title: 'A data de pesquisa tem que estar no período de 30 dias',
        confirmButtonText: 'Tentar novamente',
      });
      return false;
    }

    if (!transfersState.isLoading)
      dispatch(getApiTransfer(transfersFilterState));

    return false;
  }

  const boxStyle = {
    paddingRight: 0,
    paddingLeft: 0,
  };
  return (
    <Filter.Default
      style={{
        paddingTop: '1rem',
      }}>
      <Filter.Box>
        <Wrapper.Default
          isActive
          flexDirection="row"
          alignItens="start"
          justifyContent="start"
          padding="0"
          width="50%">
          <SetPartner />
          <SetType />
        </Wrapper.Default>

        <Filter.Button onClick={() => setCollapse(!collapse)}>
          {collapse ? 'Menos filtros' : 'Mais filtros'}
          <svg
            width="28"
            height="28"
            viewBox="0 0 28 28"
            fill="none"
            style={collapse ? {} : { transform: 'rotate(180deg)' }}
            xmlns="http://www.w3.org/2000/svg">
            <path
              d="M7.82823 21.3381C7.93617 21.4462 8.06437 21.532 8.20551 21.5906C8.34664 21.6491 8.49794 21.6793 8.65074 21.6793C8.80353 21.6793 8.95483 21.6491 9.09597 21.5906C9.2371 21.532 9.3653 21.4462 9.47324 21.3381L13.9999 16.8231L18.5382 21.3497C18.6462 21.4578 18.7745 21.5434 18.9156 21.6019C19.0567 21.6603 19.208 21.6904 19.3607 21.6904C19.5135 21.6904 19.6647 21.6603 19.8059 21.6019C19.947 21.5434 20.0752 21.4578 20.1832 21.3497C20.2912 21.2417 20.3769 21.1135 20.4354 20.9724C20.4938 20.8312 20.5239 20.68 20.5239 20.5272C20.5239 20.3745 20.4938 20.2232 20.4354 20.0821C20.3769 19.941 20.2912 19.8128 20.1832 19.7047L14.8282 14.3497C14.3732 13.8947 13.6382 13.8947 13.1832 14.3497L7.82823 19.7047C7.72016 19.8115 7.63435 19.9387 7.57578 20.0789C7.51721 20.2191 7.48706 20.3695 7.48706 20.5214C7.48706 20.6733 7.51721 20.8238 7.57578 20.9639C7.63435 21.1041 7.72016 21.2313 7.82823 21.3381Z"
              fill="#115C5B"
            />
            <path
              d="M7.82843 13.6496C7.93636 13.7577 8.06456 13.8436 8.2057 13.9021C8.34683 13.9606 8.49813 13.9908 8.65093 13.9908C8.80373 13.9908 8.95502 13.9606 9.09616 13.9021C9.23729 13.8436 9.36549 13.7577 9.47343 13.6496L14.0001 9.1346L18.5268 13.6613C18.7449 13.8794 19.0408 14.002 19.3493 14.002C19.6578 14.002 19.9536 13.8794 20.1718 13.6613C20.3899 13.4431 20.5125 13.1473 20.5125 12.8388C20.5125 12.5303 20.3899 12.2344 20.1718 12.0163L14.8168 6.66126C14.3618 6.20626 13.6268 6.20626 13.1718 6.66126L7.81676 12.0163C7.60258 12.2349 7.48359 12.5293 7.48577 12.8353C7.48796 13.1414 7.61114 13.4341 7.82843 13.6496Z"
              fill="#115C5B"
            />
          </svg>
        </Filter.Button>
      </Filter.Box>
      <Filter.Box>
        <SetPeriod />
        <SetValue />
        <SetDatetime />
      </Filter.Box>
      {collapse && (
        <>
          <Filter.Divisor />
          <Filter.Title>Creditado</Filter.Title>
          <Filter.Box style={boxStyle}>
            <SetNameCred />
            <SetDocumentCred />
            <SetAgencyCred />
            <SetAccountCred />
          </Filter.Box>
          <Filter.Divisor />
          <Filter.Title>Debitado</Filter.Title>
          <Filter.Box style={boxStyle}>
            <SetNameDeb />
            <SetDocumentDeb />
            <SetAgencyDeb />
            <SetAccountDeb />
          </Filter.Box>
          <Filter.Divisor />
          <Filter.Box>
            <SetCodLeg />
            <SetIDTransaction />
            <SetSituation />
          </Filter.Box>
          <Filter.Divisor />
        </>
      )}
      <Filter.Box>
        <SearchButton
          onClick={() => dispathData()}
          justifyContent="center"
          width="10rem"
          margin="0 0 0 auto"
          disabled={transfersState.isLoading}>
          <span style={{ marginRight: '5px' }}>Pesquisar</span>
        </SearchButton>
      </Filter.Box>
    </Filter.Default>
  );
}

export default transfersFilter;
